"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.leaderboardContract = void 0;
const core_1 = require("@ts-rest/core");
const leaderboard_admin_contract_1 = require("./leaderboard.admin.contract");
const leaderboard_auth_contract_1 = require("./leaderboard.auth.contract");
const leaderboard_public_contract_1 = require("./leaderboard.public.contract");
const c = (0, core_1.initContract)();
exports.leaderboardContract = c.router({
    admin: leaderboard_admin_contract_1.adminLeaderboardContract,
    auth: leaderboard_auth_contract_1.authLeaderboardContract,
    public: leaderboard_public_contract_1.publicLeaderboardContract,
}, {
    pathPrefix: '/draw/leaderboard',
    strictStatusCodes: true,
});
__exportStar(require("./leaderboard.admin.contract"), exports);
__exportStar(require("./leaderboard.auth.contract"), exports);
__exportStar(require("./leaderboard.public.contract"), exports);
__exportStar(require("./models"), exports);
//# sourceMappingURL=index.js.map